import { download, humanReadableSize } from '../../utils/easy';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';

export interface DownloadProgressProps extends DialogProps {
  url: string;
}

class DownloadDialog extends DialogComponent<DownloadProgressProps> {

  state = {
    total: 0,
    downloaded: 0
  }

  render() {
    const { downloaded, total } = this.state;
    const percent = Math.ceil(downloaded * 100 / total);
    return (
      <>
        <div className="text-center mb-3 ltr" style={{ fontSize: '0.95rem' }}>
          {humanReadableSize(downloaded)}/{humanReadableSize(total)}
        </div>
        <div className="progress" style={{ height: '1.9rem' }}>
          <div
            style={{ width: percent + '%', fontWeight: 500, fontSize: '0.9rem' }}
            className="progress-bar bg-success">
            {percent}%
          </div>
        </div>
      </>
    );
  }

  componentDidMount = async () => {
    await download(this.props.url, (event: ProgressEvent) => {
      this.setState({
        total: event.total,
        downloaded: event.loaded
      })
    });
  }

}

export default DownloadDialog;
